import { render, staticRenderFns } from "./FullscreenGallery.vue?vue&type=template&id=41d9646c&scoped=true&"
import script from "./FullscreenGallery.vue?vue&type=script&lang=ts&"
export * from "./FullscreenGallery.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenGallery.vue?vue&type=style&index=0&id=41d9646c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d9646c",
  null
  
)

export default component.exports